// extracted by mini-css-extract-plugin
export default {"main-container":"OnboardingProject_main-container__aHM3k","register-container":"OnboardingProject_register-container__H4tn1","loader":"OnboardingProject_loader__AJHXb"};